export default {
  DROPDOWN: 'dropdown',
  INPUT: 'input',
  SELECT: 'select',
};
